export default __webpack_public_path__ + "static/media/promotion_img.836a7abb.svg";